import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "RithoricQuestionButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, currentDialog, markAsRithoric} = useTextareaComponent();

let isCanRithoricQuestion = computed(() => {
    if (OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canRithoricQuestion, client.value.siteId)) {
        return !!currentDialog.value;
    }
    return false;
});



return (_ctx: any,_cache: any) => {
  return (_unref(isCanRithoricQuestion))
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
        key: 0,
        icon: "snooze",
        tooltip: _unref(__)('Обращение не требует ответа'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(markAsRithoric)(true)))
      }, null, 8, ["tooltip"]))
    : _createCommentVNode("", true)
}
}

})